import { IChildrenProps } from '@dataplace.ai/types'
import React from 'react'

export const AvoidPrintPageBreak = ({ children }: IChildrenProps): JSX.Element => <div className='avoid-page-break'>{children}</div>
